import React from 'react';
import styled from 'styled-components';
import { mediaQuery } from '../../../common/styles/styleUtil';
import { ExpandableBlockLoader } from '../../loader/BlockLoader.style';

interface SectionLoaderProps {
  height: [mobile: number, tablet: number, desktop: number];
  noMargin?: boolean;
}

const SectionLoaderWrapper = styled.div<{
  height: [mobile: number, tablet: number, desktop: number];
  noMargin?: boolean;
}>`
  height: ${(props) => `${props.height[2]}px`};
  margin-top: 40px;
  margin-bottom: 40px;
  ${(props) => (props.noMargin ? 'margin: 0' : '')};

  @media (${mediaQuery.tablet}) {
    height: ${(props) => `${props.height[1]}px`};
    margin-top: 32px;
    margin-bottom: 32px;
    ${(props) => (props.noMargin ? 'margin: 0' : '')};
  }

  @media (${mediaQuery.mobile}) {
    height: ${(props) => `${props.height[0]}px`};
  }
`;

const SectionLoader: React.FC<SectionLoaderProps> = ({ height, noMargin }) => {
  return (
    <SectionLoaderWrapper height={height} noMargin={noMargin}>
      <ExpandableBlockLoader />
    </SectionLoaderWrapper>
  );
};

export default SectionLoader;
